<template>
  <div class="NSPCC-footer">
    <div class="site-row site-row--page-footer">
      <footer class="page-footer">
        <section id="deepFooter">
          <div class="page">
            <section class="helplines collapsible">
              <h2>Contact us</h2>
              <div class="cmenu">
                <p>
                  <a href="https://learning.nspcc.org.uk/contact-us/"
                    >For safeguarding training, resources and consultancy</a
                  >
                  <br />Call us on 0116 234 7246
                  <br />
                  <br /><a
                    href="https://www.nspcc.org.uk/what-you-can-do/report-abuse/"
                    >Help for adults concerned about a child</a
                  >
                  <br />Call us on 0808 800 5000
                  <br />
                  <br /><a href="http://www.childline.org.uk"
                    >Help for children and young people</a
                  >
                  <br />Call Childline on 0800 1111
                </p>
              </div>
            </section>
            <section class="linksList collapsible">
              <h2>Links</h2>
              <div class="cmenu">
                <ul>
                  <li v-for="page in root" :key="page.pageName">
                    <a :href="page.url">{{ page.pageName }}</a>
                  </li>
                  <li>
                    <a
                      href="https://mylearning.nspcc.org.uk/AccountLogin.aspx"
                      target="_blank"
                      >Log in to my learning</a
                    >
                  </li>
                  <li><a href="/contact-us/" target="_blank">Contact us</a></li>
                  <li><button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button></li>
                </ul>
              </div>
            </section>
            <section class="followUs">
              <h2>Follow us</h2>
              <ul>
                <li>
                  <a
                    href="https://facebook.com/NSPCC"
                    class="icon-facebook"
                    target="_blank"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/165248/"
                    class="icon-linkedin"
                    target="_blank"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/user/nspcc"
                    class="icon-youtube"
                    target="_blank"
                  ></a>
                </li>
              </ul>
            </section>
            <section class="legal">
              <h2>The NSPCC</h2>
              <p>
                <span
                  >Weston House, 42 Curtain Road, London, EC2A 3NH. Incorporated
                  by Royal Charter</span
                >
              </p>
              <p>
                <span
                  >Registered charity number 216401. NSPCC, charity registered
                  in Scotland, charity number SC037717. Jersey registered
                  charity number AJC179.</span
                >
              </p>
            </section>

            <hr />

            <section class="copyright">
              <div class="footer__meta category-text">
                <p class="footer__meta-copyright">
                  Copyright ©
                  {{ new Date().getFullYear() }} NSPCC / All rights reserved.
                  National Society for the Prevention of Cruelty to Children.
                </p>
              </div>
            </section>

            <section class="legalLinks">
              <ul>
                <li><a href="/sitemap/" target="_blank">Sitemap</a></li>
                <li>
                  <a
                    href="https://www.nspcc.org.uk/terms-conditions/"
                    target="_blank"
                    >Terms of use</a
                  >
                </li>
                <li>
                  <a href="/terms-of-supply/" target="_blank"
                    >Terms of supply</a
                  >
                </li>
                <!-- <li>
                  <a class="ot-sdk-show-settings">Cookie Settings</a>
                </li> -->
                <li>
                  <a
                    href="https://learning.nspcc.org.uk/cookies-policy/"
                    target="_blank"
                    >Cookies</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.nspcc.org.uk/privacy-policy/"
                    target="_blank"
                    >Privacy</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.nspcc.org.uk/accessibility/"
                    target="_blank"
                    >Accessibility</a
                  >
                </li>
              </ul>
            </section>
            <!-- <section class="credit">
              <p><a href="https://addition.london/" target="_blank"></a></p>
            </section>
            <img
              id="regulator"
              src="~@/assets/images/FR-Logo.png"
              alt="Registered with Fundraising Regulator"
              width="225"
              height="69"
            /> -->
          </div>
        </section>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"

export default {
  name: "FooterBar",
  data() {
    return {
      root: []
    };
  },
  async created() {
    const footer=await this.getFooterNav();
    if(footer!=undefined)
    this.root = [...footer];
  },
   methods: {
    ...mapActions("util", ["getFooterNav"])
   }
};
</script>
<style lang="scss">
@import "@/assets/sass/variables.scss";
@import "@/assets/sass/mixins.scss";
@import "@/assets/sass/typography.scss";
@import "@/assets/sass/footer.scss";
</style>
